(() => {
  function buildTitleQuery(raw) {
    return raw
      .trim()
      .split(/\s+/)
      .map((word) => word.replace(/[\\():*"']/g, ""))
      .filter(Boolean)
      .map((word) => `title:${word}*`)
      .join(" AND ");
  }

  // 将 title:Trench* 转换成客户看到的 Trench
  function cleanDisplayedQuery(raw) {
    return raw
      .replace(/\btitle:/gi, "")
      .replace(/\*/g, "")
      .replace(/\s+AND\s+/gi, " ")
      .trim();
  }

  // 搜索结果页加载后，隐藏 title:、* 和 AND
  function cleanSearchInputs() {
    document
      .querySelectorAll('form[action*="/search"] input[name="q"]')
      .forEach((input) => {
        if (input.value.includes("title:")) {
          input.value = cleanDisplayedQuery(input.value);
        }
      });
  }

  cleanSearchInputs();

  document.addEventListener("DOMContentLoaded", cleanSearchInputs);

  // 客户重新搜索时，再添加只搜索标题的语法
  document.addEventListener("submit", (event) => {
    const form = event.target;

    if (
      !(form instanceof HTMLFormElement) ||
      !form.matches('form[action*="/search"]')
    ) {
      return;
    }

    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    const raw = input.value.trim();

    if (raw && !raw.includes("title:")) {
      input.value = buildTitleQuery(raw);
    }
  });
})();